import { RootModule } from '@uirouter/angular';
import { states } from './seatselection-routing.states';

export const config: RootModule = {
  states: states,
  // otherwise: {state: 'common.select.landing'},
  // initial: {state: 'common.select.landing'},
  useHash: false,
};
